(function () {
    angular.module('tmx-app')
        .directive('tmxUploadFile', [tmxUploadFile]);

    function tmxUploadFile() {

        var directive = {
            restrict: 'E',
            scope: {
                url: '@',
                responseType:'@',
                shouldShowResponseDialog: '=', // In case any upload requires some custom work to be done
                acceptFiles: '@',
                afterUpload: '=',
                successMsg: '@',
                disableDone: '=', // To disable the button
                showDownloadTemplateOption: "=", // To show the download template option
                showUploadStatusOption: "=",
                downloadTemplateEvent: "&", // Event call back when download template is clicked
                uploadStatusState: "@"
            },
            templateUrl: 'common/directives/tmxuploadfile/tmxuploadfile.html',
            controller: ['$scope','$state', '$filter', 'TmxDialogService', 'fileUpload', 'ToastService',tmxUploadFileCtrl],
            controllerAs: 'TmxUploadFileCtrl'
        };
        return directive;
    }

    function tmxUploadFileCtrl($scope,$state, $filter, TmxDialogService, fileUpload,ToastService) {
        var vm = this;
        vm.scope = $scope;
        vm.uploadProgress = 0;

        if (!vm.scope.acceptFiles) {
            vm.scope.acceptFiles = '.csv,.xls,.xlsx';
        }

    /* Disable the buttons when the request is in progress */

    // $scope.$watch(function () { return cfpLoadingBar.status(); },
    //   function (newValue, oldValue) {
    //     if (newValue !== oldValue) {
    //       vm.disableDone = newValue > 0;
    //     }
    //   });


        vm.upload = function () {
            var file = vm.files[0];
            var acceptExt = vm.scope.acceptFiles.split(',');
            var fileAccepted = false;
            for (var i = 0; i < acceptExt.length; i++) {
                if (vm.files[0].name.substring(vm.files[0].name.lastIndexOf('.'), vm.files[0].name.length) == acceptExt[i]) {
                    fileAccepted = true;
                }
            }
            if (!fileAccepted) {
                vm.error = "Invalid file format. Expected file format(s): " + vm.scope.acceptFiles;
                return;
            }
            fileUpload.upload(file, vm.scope.url,undefined,vm.scope.responseType)
                .then(function (resp) {
                    if (!angular.isDefined(vm.scope.shouldShowResponseDialog) || vm.scope.shouldShowResponseDialog == true) {
                        if (resp && resp.data && resp.data.status && resp.data.status.message) {
                            vm.showErrorDialog(resp.data.status.message);
                        }
                        else {
                            ToastService.showCustomToast("success", vm.scope.successMsg ? vm.scope.successMsg : "Upload Successful");
                        }
                    }


                    if (vm.scope.afterUpload)
                        vm.scope.afterUpload(resp);
                }, function (resp) {

                    if (vm.scope.afterUpload)
                        vm.scope.afterUpload(resp);
                }).finally(function () {
                    vm.removeAllFiles();
                });

        };

        vm.downloadTemplateClicked = function() {

            if(angular.isDefined(vm.scope.downloadTemplateEvent) && angular.isFunction(vm.scope.downloadTemplateEvent())) {
                vm.scope.downloadTemplateEvent()();        
            }
        };
        vm.viewUploadStatusClicked = function() {

            if(angular.isDefined(vm.scope.uploadStatusState)) {
                $state.go(vm.scope.uploadStatusState.toLowerCase());
            }
        };


        vm.cancel = function () {
            vm.error = undefined;
            vm.removeAllFiles();
        };

        vm.showErrorDialog = function (errorMsg) {
            var diagConfig = {
                action: "Error on Import",
                entity: "",
                details: [
                    { value: errorMsg.replace(/(?:\r\n|\r|\n)/g, '<br/>') },
                ],
                options: [
                    { label: $filter('translate')("Ok"), value: false, class: "md-primary" }
                ],
                showConfirmationMsg: false
            };
            var locationDeactivateDialog = new TmxDialogService.confirmDialog(diagConfig);

            locationDeactivateDialog.show();
        };

        vm.removeAllFiles = function () {
            vm.files = null;
        };
    }
})();